import { render, staticRenderFns } from "./Result1.vue?vue&type=template&id=156808a0&scoped=true"
import script from "./Result1.vue?vue&type=script&lang=js"
export * from "./Result1.vue?vue&type=script&lang=js"
import style0 from "./Result1.vue?vue&type=style&index=0&id=156808a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156808a0",
  null
  
)

export default component.exports